export const arrayContentsEqual = <T>(a: Array<T>, b: Array<T>) =>
  Array.isArray(a) &&
  Array.isArray(b) &&
  a.length === b.length &&
  a.every((val, index) => val === b[index]);

export const last = <T>(a: Array<T>) => {
  return Array.isArray(a) ? a.slice(-1).pop() : undefined
};
